/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  MatLegacySelectionList as MatSelectionList,
  MatLegacySelectionListChange as MatSelectionListChange,
} from '@angular/material/legacy-list';
import { CockpitManualService } from 'src/app/shared/services/cockpit-manual.service';

export interface FilterPreset {
  label: string;
  value: string;
  visible: boolean;
  presetCopy: any;
}

/**
 * Saved filter presets column (create / delete / set-as-default actions).
 * Selection orchestration stays in the parent, which drives this list via
 * the exposed MatSelectionList.
 */
@Component({
  selector: 'app-filter-presets-list',
  templateUrl: './filter-presets-list.component.html',
  styleUrls: ['./filter-presets-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterPresetsListComponent {
  @ViewChild('presetsSelectionList', { static: true })
  selectionList: MatSelectionList;

  @Input() presets: FilterPreset[] = [];
  @Input() control: UntypedFormControl;
  @Input() activeFilter: string;
  @Input() idCustomDefault: any;
  @Input() nameCustomDefault: string | undefined;

  @Output() selectionChange = new EventEmitter<MatSelectionListChange>();
  @Output() save = new EventEmitter<void>();
  @Output() deletePreset = new EventEmitter<FilterPreset>();
  @Output() setDefault = new EventEmitter<FilterPreset>();
  @Output() resetDefault = new EventEmitter<void>();

  constructor(private manual: CockpitManualService) {}

  onMouseEnter(preset: FilterPreset) {
    preset.visible = true;
  }

  onMouseLeave(preset: FilterPreset) {
    preset.visible = false;
  }

  /** open the Cockpit guide at the Filters section in a new tab */
  openManual() {
    this.manual.open('filters');
  }
}
